import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'dmp-etl-popup-design-scripts',
    templateUrl: './etl-popup-design-scripts.component.html',
    styleUrls: ['./etl-popup-design-scripts.component.scss'],
    standalone: false
})
export class EtlPopupDesignScriptsComponent implements OnInit {
    @Input() public display: boolean;
    @Output() public displayChange = new EventEmitter<boolean>();
    @Input() public script: string;
    @Output() public scriptChange = new EventEmitter<string>();

    editorGroovyOptions = {
        theme: 'vs',
        lineNumbers: 'on',
        language: 'java',
        readOnly: false,
    };
    private originScriot: string;
    private validated = false;

  constructor() { }

  ngOnInit(): void {
      if (this.script == null) {
          this.script = `IataUtil.reverseFieldsDataIfValue(dataFile, ["EAP"], [
    [fieldA: "return_destination_city", fieldB: "return_destination_airport"],
    [fieldA: "return_origin_city", fieldB: "return_origin_airport"],
    [fieldA: "departure_destination_city", fieldB: "departure_destination_airport"],
    [fieldA: "departure_origin_city", fieldB: "departure_origin_airport"]
])`;
      }
      this.originScriot = this.script;
  }

    /**
     * La restauration du script est faite ici, et non dans `doCancel()`, pour que la croix en haut
     * à droite annule exactement comme le bouton « Annuler » : les deux passent forcément par
     * `(onHide)`. Le drapeau `validated` évite d'écraser un script qui vient d'être validé.
     */
    onHideDialog(event): void {
        if (!this.validated) {
            this.script = this.originScriot;
        }
        this.displayChange.emit();
    }

    onShowDialog(event): void {
        // Référence d'annulation prise à chaque ouverture : `ngOnInit` ne la capturait qu'une fois,
        // si bien qu'annuler après une validation restaurait un script périmé.
        this.originScriot = this.script;
        this.validated = false;
    }

    doCancel(): void {
        this.displayChange.emit();
    }

    doValidateAndClose(): void {
        this.validated = true;
        this.scriptChange.emit(this.script);
        this.displayChange.emit();
    }
}
